export default [
  //  支付配置-支付商列表
  {
    name: "GetPaymentChannelList",
    url: "/payment/channel/list",
    method: "GET",
    mock: false,
  },
  // 支付配置-获取支付商详情
  {
    name: "GetPaymentChannelDetail",
    url: "/payment/channel/get",
    method: "GET",
    mock: false,
  },
  // 支付配置-编辑支付商
  {
    name: "UpdatePaymentChannel",
    url: "/payment/channel/update",
    method: "POST",
    mock: false,
  },
  // 支付配置-切换支付商状态
  {
    name: "ChangePaymentChannelStatus",
    url: "/payment/channel/change-status",
    method: "POST",
    mock: false,
  },
  // 租户管理-所有租户
  {
    name: "GetTenantList",
    url: "/tenant/list/all",
    method: "GET",
    mock: false,
  },
  // 验证模块-列表
  {
    name: "GetCaptchaList",
    url: "/service/captcha/list",
    method: "GET",
    mock: false,
  },
  // 验证模块-详情
  {
    name: "GetCaptchaDetail",
    url: "/service/captcha/get",
    method: "GET",
    mock: false,
  },
  // 验证模块-编辑
  {
    name: "UpdateCaptcha",
    url: "/service/captcha/update",
    method: "POST",
    mock: false,
  },
  // 验证模块-切换状态
  {
    name: "ChangeCaptchaStatus",
    url: "/service/captcha/change-status",
    method: "POST",
    mock: false,
  },
  // 邮件服务商-列表
  {
    name: "GetEmailProviderList",
    url: "/service/email-provider/list",
    method: "GET",
    mock: false,
  },
  // 邮件服务商-详情
  {
    name: "GetEmailProviderDetail",
    url: "/service/email-provider/get",
    method: "GET",
    mock: false,
  },
  // 邮件服务商-状态切换
  {
    name: "ChangeEmailProviderStatus",
    url: "/service/email-provider/change-status",
    method: "POST",
    mock: false,
  },
  // 邮件服务商-编辑
  {
    name: "UpdateEmailProvider",
    url: "/service/email-provider/update",
    method: "POST",
    mock: false,
  },
  // 租户管理-新增租户
  {
    name: "CreateTenant",
    url: "/tenant/create",
    method: "POST",
    mock: false,
  },
  // 租户管理-删除租户
  {
    name: "DeleteTenant",
    url: "/tenant/delete",
    method: "POST",
    mock: false,
  },
  // 租户管理-获取租户详情
  {
    name: "GetTenantDetail",
    url: "/tenant/detail",
    method: "GET",
    mock: false,
  },
  // 租户管理-编辑
  {
    name: "UpdateTenant",
    url: "/tenant/update",
    method: "POST",
    mock: false,
  },
  // 租户管理-付费租户列表
  {
    name: "GetPaidTenantList",
    url: "/paid-tenant/list",
    method: "GET",
    mock: false,
  },
  // 租户管理-试用租户列表
  {
    name: "GetTrailTenantList",
    url: "/trial-tenant/list",
    method: "GET",
    mock: false,
  },
  // 租户管理-获取所有权限
  {
    name: "GetTenantAllPermissions",
    url: "/tenant/permission/list/all",
    method: "GET",
    mock: false,
  },

  // 租户管理-获取租户权限
  {
    name: "GetTenantPermissions",
    url: "/tenant/permissions",
    method: "GET",
    mock: false,
  },
  // 租户管理-保存租户权限
  {
    name: "SaveTenantPermission",
    url: "/tenant/permission/save",
    method: "POST",
    mock: false,
  },
  // 支付配置-获取币种列表
  {
    name: "GetInternalCurrencyList",
    url: "/payment/currency/list",
    method: "GET",
    mock: false,
  },

  // 租户管理-更改租户状态
  {
    name: "ChangeTenantStatus",
    url: "/tenant/status/change",
    method: "POST",
    mock: false,
  },

  // 租户管理-重置密码
  {
    name: "TenantPasswordReset",
    url: "/tenant/password/reset",
    method: "POST",
    mock: false,
  },
  // 邮件相关接口
  // 邮件服务器管理-详情
  {
    name: "InternalSettingGetEmailServerSetting",
    url: "/email-setting/server/get",
    method: "GET",
    mock: false,
  },
  // 邮件服务器管理-列表
  {
    name: "InternalSettingListEmailServerSetting",
    url: "/email-setting/server/list",
    method: "GET",
    mock: false,
  },
  // 邮件服务器管理-更新
  {
    name: "InternalSettingUpdateEmailServerSetting",
    url: "/email-setting/server/update",
    method: "POST",
    mock: false,
  },
  // 邮件模板管理-详情
  {
    name: "InternalSettingGetEmailTemplate",
    url: "/email-setting/template/get",
    method: "GET",
    mock: false,
  },
  // 邮件模板管理-列表
  {
    name: "InternalSettingListEmailTemplate",
    url: "/email-setting/template/list",
    method: "GET",
    mock: false,
  },
  // 触发行为选项-列表
  {
    name: "InternalSettingListTriggerActionOption",
    url: "/email-setting/template/list-trigger-action-option",
    method: "GET",
    mock: false,
  },
  // 邮件模板管理-更新
  {
    name: "InternalSettingUpdateEmailTemplate",
    url: "/email-setting/template/update",
    method: "POST",
    mock: false,
  },
  // 邮件服务器管理-发送测试邮件
  {
    name: "InternalSettingTestEmailServer",
    url: "/email-setting/server/test",
    method: "POST",
    mock: false,
  },
  // 邮件模板管理-更新状态
  {
    name: "InternalSettingUpdateStatusEmailTemplate",
    url: "/email-setting/template/update-status",
    method: "POST",
    mock: false,
  },
  // 邮件模板管理-发送测试邮件
  {
    name: "InternalSettingTestEmailTemplate",
    url: "/email-setting/template/test",
    method: "POST",
    mock: false,
  },
  // 租户管理-测试MySQL连通性
  {
    name: "TenantTestMysql",
    url: "/tenant/test/mysql",
    method: "POST",
    mock: false,
  },

  // 租户管理-测试Redis连通性
  {
    name: "TenantTestRedis",
    url: "/tenant/test/redis",
    method: "POST",
    mock: false,
  },
  // 超管端登录
  {
    name: "AuthStaffLogin",
    url: "/auth/staff/login",
    method: "POST",
    mock: false,
  },
  // 租户管理-迁移租户数据(初始化数据)
  {
    name: "TenantMigrate",
    url: "/tenant/migrate",
    method: "POST",
    mock: false,
  },
  // 租户管理-获取申请租户列表
  {
    name: "ApplicationTenantList",
    url: "/application-tenant/list",
    method: "GET",
    mock: false,
  },
  // 租户管理-获取MySQL&Redis默认连接信息
  {
    name: "TenantSystemConfig",
    url: "/system/config",
    method: "GET",
    mock: false,
  },
  // 电子验证服务商-状态切换
  {
    name: "ElectronicVerificationChangeStatus",
    url: "/service/e-verify/change-status",
    method: "POST",
    mock: false,
  },
  // 电子验证服务商-获取详情
  {
    name: "ElectronicVerificationGet",
    url: "/service/e-verify/get",
    method: "GET",
    mock: false,
  },
  // 电子验证服务商-获取列表
  {
    name: "ElectronicVerificationList",
    url: "/service/e-verify/list",
    method: "GET",
    mock: false,
  },
  // 电子验证服务商-编辑
  {
    name: "ElectronicVerificationUpdate",
    url: "/service/e-verify/update",
    method: "POST",
    mock: false,
  },
  // openApiKey 相关接口

  // 创建API Key
  {
    name: "CreateApiKey",
    url: "/openapi/api-key/create",
    method: "POST",
    mock: false,
  },
  // 删除API Key
  {
    name: "DeleteApiKey",
    url: "/openapi/api-key/delete",
    method: "POST",
    mock: false,
  },
  // 查询API Key详情
  {
    name: "GetApiKey",
    url: "/openapi/api-key/get",
    method: "GET",
    mock: false,
  },
  // 获取API Key列表
  {
    name: "ListApiKey",
    url: "/openapi/api-key/list",
    method: "GET",
    mock: false,
  },
  // 列出可选租户 
  {
    name: "ListAvailableTenants",
    url: "/openapi/api-key/list-available-tenants",
    method: "GET",
    mock: false,
  },
  // 更新API Key 
  {
    name: "UpdateApiKey",
    url: "/openapi/api-key/update",
    method: "POST",
    mock: false,
  },
];
